"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.843 17H11v-5H6.006c.048 1.814.35 3.524.837 5Zm.374 1c.917 2.182 2.273 3.68 3.783 3.955V18H7.217Zm-4.658-1h3.207c-.45-1.49-.718-3.184-.76-5H1.012a10.431 10.431 0 0 0 1.547 5Zm.7 1a10.54 10.54 0 0 0 4.958 3.475c-.847-.86-1.568-2.05-2.111-3.475H3.259ZM20.441 6h-3.207c.45 1.49.718 3.184.76 5h3.994a10.43 10.43 0 0 0-1.547-5Zm-.7-1a10.54 10.54 0 0 0-4.958-3.475c.847.86 1.568 2.05 2.111 3.475h2.847Zm-3.584 1H12v5h4.994c-.048-1.814-.35-3.524-.837-5Zm-.374-1C14.866 2.818 13.51 1.32 12 1.045V5h3.783Zm-8.94 1c-.488 1.476-.79 3.186-.837 5H11V6H6.843Zm.374-1H11V1.045C9.49 1.32 8.134 2.818 7.217 5ZM2.559 6a10.431 10.431 0 0 0-1.547 5h3.994c.042-1.816.31-3.51.76-5H2.559Zm.7-1h2.847c.543-1.426 1.264-2.615 2.111-3.475A10.54 10.54 0 0 0 3.26 5Zm18.728 7H12v4.216h3.767l1.258-3.872c.134-.412.817-.412.951 0l1.258 3.872h4.071a.5.5 0 0 1 .294.905l-3.298 2.397 1.178 3.834A.502.502 0 0 1 21 24a.492.492 0 0 1-.295-.097L17.5 21.554l-3.205 2.349a.498.498 0 0 1-.773-.551l1.178-3.834-2.7-1.962v4.43c.22-.01.437-.029.654-.052a.5.5 0 1 1 .108.994A11.67 11.67 0 0 1 11.5 23C5.159 23 0 17.841 0 11.5S5.158 0 11.5 0 23 5.159 23 11.5c0 .405-.023.818-.072 1.262a.5.5 0 1 1-.994-.108c.024-.216.042-.434.053-.654ZM17.5 20.434c.104 0 .208.032.295.097l2.284 1.674-.84-2.734a.498.498 0 0 1 .184-.551l2.342-1.702h-2.896a.5.5 0 0 1-.476-.346l-.895-2.753-.895 2.753a.5.5 0 0 1-.476.346h-2.896l2.342 1.702a.499.499 0 0 1 .184.551l-.84 2.734 2.284-1.674a.52.52 0 0 1 .299-.097Z",
    clipRule: "evenodd"
  })]
});